/* Built In Imports */

/* External Imports */
import { Box, Heading, Image, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import Slider from 'react-slick';

/* Components */
import CardMsr1ColumnSliderGrouph from '@msr/components/Card/CardMsr1ColumnSliderGrouph';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/* Internal Imports */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
/* Services */

/**
 * Renders the Card Info 1 Card component
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} CardGrid Card component
 */
const MsrImageGallery = ({ sectionContent, lang, region }) => {
  return (
    <Box mx="auto" w="full">
      <Box m="30px auto 0 auto" pb="20px" w={{ base: '100%', md: '100%' }}>
        <MsrSectionTitle
          pt="0"
          mt="0"
          fontSize="34px"
          titleObj={sectionContent[0]}
          w={{
            base: 'auto',
            md: '515px',
            lg: '900px',
          }}
          maxwidth={'900px'}
          fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSerifAStdBook'}
          fontWeight={lang == 'ta' ? '600' : '500'}
          color="#FFF7E9"
        />
      </Box>
      <Box className="imagegallery">
        <CardMsr1ColumnSliderGrouph
          sectionContent={sectionContent[1]}
          region={region}
          lang={lang}
        />
      </Box>
      <style global jsx>
        {`
          @media (max-width: 767px) {
            .imagegallery img {
              width: 273px;
              height: 164px;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default MsrImageGallery;
